import * as React from 'react'
import { useParams } from 'react-router-dom'
import PageLayout from '@/components/ui/page-layout'
import PlanForm from '@/features/plans/components/PlanForm'

export default function EditPlanRoute() {
    const { id } = useParams()
    const breadcrumbs = [
        { label: 'Plans', href: '/plans' },
        { label: `Edit${id ? ` • ${id}` : ''}`, href: id ? `/plans/edit/${id}` : '/plans/edit' },
    ]

    return (
        <PageLayout title='Edit Plan' subtitle={id ? `Editing plan ${id}` : undefined} breadcrumbs={breadcrumbs}>
            <div className='max-w-2xl'>
                <PlanForm />
            </div>
        </PageLayout>
    )
}


